"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mimeTypeMatchesWildCard = exports.isValidMimeType = exports.guesstimateMimeType = void 0;
const images = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff"];
const text = ["css", "csv", "html", "txt"];
const map = {
  zip: "zip|compressed",
  epub: "application/epub+zip"
};
const guesstimateMimeType = (extension = "") => {
  extension = extension.toLowerCase();
  if (images.includes(extension)) {
    return "image/" + (extension === "jpg" ? "jpeg" : extension === "svg" ? "svg+xml" : extension);
  }
  if (text.includes(extension)) {
    return "text/" + extension;
  }
  return map[extension] || "";
};
exports.guesstimateMimeType = guesstimateMimeType;
const mimeTypeMatchesWildCard = (mimeType, wildcard) => {
  const mimeTypeGroup = (/^[^/]+/.exec(mimeType) || []).pop();
  const wildcardGroup = wildcard.slice(0, -2);
  return mimeTypeGroup === wildcardGroup;
};
exports.mimeTypeMatchesWildCard = mimeTypeMatchesWildCard;
const isValidMimeType = (acceptedTypes, type) => {
  return acceptedTypes.some(acceptedType => {
    if (/\*$/.test(acceptedType)) {
      return mimeTypeMatchesWildCard(type, acceptedType);
    }
    return acceptedType === type;
  });
};
exports.isValidMimeType = isValidMimeType;